import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EmpresaService } from 'src/app/services/empresa.service';
import { Router } from '@angular/router';
interface Rol {
  label: string;
  value: number;
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [MessageService]
})
export class RegisterComponent implements OnInit {
  public usuarioForm: FormGroup;
  roles: Rol[];

  constructor(
    private fb: FormBuilder,
    private empresaService: EmpresaService,
    private messageService: MessageService,
    private router: Router
  ) {
    this.roles = [
      { label: 'Administrador', value: 1 },
      { label: 'Empresa', value: 2 }
    ];

    this.usuarioForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      contrasena: ['', [Validators.required, Validators.minLength(6)]],
      nombre: ['', Validators.required],
      rfc: ['', [Validators.required, Validators.maxLength(13), Validators.pattern('[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}')]],
      entidad_federativa: ['', Validators.required],
      codigo_postal: ['', [Validators.pattern('^[0-9]{5}$')]],
      nombre_contacto: ['', Validators.required],
      telefono: ['', [Validators.required, Validators.pattern('^[0-9]{10,13}$')]],
      manifiesto: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
      fk_rol: [2, Validators.required]
    });
  }

  ngOnInit() { }

  get f() {
    return this.usuarioForm.controls;
  }
  get avisoPrivacidadInvalid() {
    const c = this.f['manifiesto'];
    return c.touched && c.invalid; // muestra error solo si tocado e inválido
  }
  onSubmit() {
    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      return;
    }
    // aquí enviarías this.usuarioForm.value al backend
    const raw = this.usuarioForm.getRawValue();
    const payload = {
      ...raw,
      // ✅ convertir booleano a numérico para la API
      manifiesto: raw.manifiesto ? 1 : 0
    };

    console.log('Formulario válido:', payload);

    this.empresaService.create(payload)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.out();

        },
        error: (err) => { this.showWarning(err.mensaje); }
      });

  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
  out(): void {
    this.router.navigate(['/']);
  }
}
